import React from 'react'
import { Helmet } from 'react-helmet'
import Carousel from './Carousel'
import WhoAmI from './WhoAmI'
import Impact from './Impact'
import Init from './Init'
import MidContactUs from './MidContactUs'
import WhoWeHelp from './WhoWeHelp'
import WeServe from './WeServe'
import Mangemnet from './Mangemnet'
import LatestBlog from './LatestBlog'
import TestimonialCarousel from './TestimonialCarousel'
import Stategry from './stategry'
import Faq from './Faq'
import OurClients from './OurClients'
import CourseHome from './CourseHome'

const Home = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name='description' content='Unlock your business potential with Umang Ratani Consultancy. Expert guidance in strategy, growth, and innovation. Partner with us for transformative success.' />
                <title>Umang Ratani Business Consultancy: Expert Solutions for Success</title>
            </Helmet>
            <Carousel />
            <WhoAmI />
            <Impact />
            <Mangemnet />
            <Stategry />
            <MidContactUs />
            <Init />
            <WhoWeHelp />
            <CourseHome/>
            <WeServe />
            <TestimonialCarousel />
            <LatestBlog />
            <OurClients />
            <Faq />
        </>
    )
}

export default Home
